import script from "./MobilePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./MobilePreview.vue?vue&type=script&setup=true&lang=js"

import "./MobilePreview.vue?vue&type=style&index=0&id=586836db&scoped=true&lang=css"

import exportComponent from "/Users/canfengchen/eclipse-workspace/gsjy/dxzjapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586836db"]])

export default __exports__